// extracted by mini-css-extract-plugin
export default {"toolkit":"LanguageToolkit_toolkit__cMaaQ"};